// components/TermsOfService.jsx
import React from 'react';
import '../styles/PrivacyPolicy.css'; // Reuse the same styles
import Navbar from '../component/Navbar';
import Footer from '../component/Footer';

const TermsOfService = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="privacy-policy-page">
     <Navbar/>
      {/* Header */}
      <div className="privacy-policy-header">
        <div className="privacy-policy-header-bg">
          <div className="privacy-policy-header-circle privacy-policy-header-circle-1"></div>
          <div className="privacy-policy-header-circle privacy-policy-header-circle-2"></div>
        </div>
        <div className="privacy-policy-header-content">
          <h1 className="privacy-policy-title">Terms of Service</h1>
          <p className="privacy-policy-subtitle">
            Please read these terms carefully before using our services.
          </p>
          <p className="privacy-policy-date">Last Updated: January 1, 2026</p>
        </div>
      </div>

      {/* Content */}
      <div className="privacy-policy-container">
        <div className="privacy-policy-content">
          <section className="privacy-policy-section">
            <h2 className="privacy-policy-section-title">1. Acceptance of Terms</h2>
            <p className="privacy-policy-section-text">
              By using the WaterDamagePro website and services, you agree to be bound by these 
              Terms of Service. If you do not agree to these terms, please do not use our services.
            </p>
          </section>

          <section className="privacy-policy-section">
            <h2 className="privacy-policy-section-title">2. Services Provided</h2>
            <p className="privacy-policy-section-text">
              WaterDamagePro provides water damage restoration services including but not limited to:
            </p>
            <ul className="privacy-policy-ul">
              <li>Emergency water extraction and removal</li>
              <li>Structural drying and dehumidification</li>
              <li>Mold remediation and testing</li>
              <li>Water damage repair and restoration</li>
              <li>Flood cleanup and damage mitigation</li>
              <li>Sewage cleanup and sanitization</li>
              <li>Pipe burst repair and water damage restoration</li>
              <li>Commercial and residential restoration</li>
              <li>Storm damage restoration</li>
            </ul>
          </section>

          <section className="privacy-policy-section">
            <h2 className="privacy-policy-section-title">3. Booking and Appointments</h2>
            <p className="privacy-policy-section-text">
              When you book a service with us:
            </p>
            <ul className="privacy-policy-ul">
              <li>You agree to provide accurate and complete information</li>
              <li>You agree to be available at the scheduled appointment time</li>
              <li>You agree to pay the quoted price for services rendered</li>
              <li>Cancellations require at least 2 hours notice</li>
              <li>Emergency services are available 24/7 with priority response</li>
            </ul>
          </section>

          <section className="privacy-policy-section">
            <h2 className="privacy-policy-section-title">4. Pricing and Payment</h2>
            <p className="privacy-policy-section-text">
              All prices are quoted in US dollars. Payment is due upon completion of services.
              We accept all major credit cards, debit cards, and cash payments.
            </p>
            <p className="privacy-policy-section-text">
              Upfront pricing is provided before any work begins. Any additional work outside 
              the original scope will be quoted and approved before proceeding.
            </p>
            <p className="privacy-policy-section-text">
              We work directly with most major insurance companies to help you with your 
              insurance claims. Please contact us for more details about insurance billing.
            </p>
          </section>

          <section className="privacy-policy-section">
            <h2 className="privacy-policy-section-title">5. User Responsibilities</h2>
            <p className="privacy-policy-section-text">
              You agree to:
            </p>
            <ul className="privacy-policy-ul">
              <li>Provide safe access to the work area</li>
              <li>Inform us of any known hazards or issues</li>
              <li>Not misuse or abuse our services</li>
              <li>Comply with all applicable laws and regulations</li>
              <li>Notify us immediately of any water damage or emergency</li>
            </ul>
          </section>

          <section className="privacy-policy-section">
            <h2 className="privacy-policy-section-title">6. Limitation of Liability</h2>
            <p className="privacy-policy-section-text">
              WaterDamagePro is not liable for any indirect, incidental, or consequential damages 
              arising from the use of our services. Our total liability is limited to the 
              amount paid for the specific service rendered.
            </p>
            <p className="privacy-policy-section-text">
              We are not responsible for damages caused by pre-existing conditions, structural 
              issues, or events beyond our reasonable control.
            </p>
          </section>

          <section className="privacy-policy-section">
            <h2 className="privacy-policy-section-title">7. Warranty and Guarantee</h2>
            <p className="privacy-policy-section-text">
              We stand behind our work with a 100% satisfaction guarantee. If you are not satisfied 
              with our service, contact us within 30 days and we will make it right.
            </p>
            <p className="privacy-policy-section-text">
              Our work is warranted against defects in workmanship for a period of 12 months 
              from the date of service completion. This warranty is limited to the specific 
              services provided and does not cover damage caused by unrelated events.
            </p>
          </section>

          <section className="privacy-policy-section">
            <h2 className="privacy-policy-section-title">8. Insurance Claims</h2>
            <p className="privacy-policy-section-text">
              WaterDamagePro assists with insurance claims for covered water damage events. 
              We work directly with your insurance company to help process your claim.
            </p>
            <p className="privacy-policy-section-text">
              You are responsible for understanding your insurance coverage and any deductibles 
              or exclusions that may apply. We recommend reviewing your policy carefully.
            </p>
          </section>

          <section className="privacy-policy-section">
            <h2 className="privacy-policy-section-title">9. Emergency Response</h2>
            <p className="privacy-policy-section-text">
              We provide 24/7 emergency response services. Our goal is to respond to all 
              emergency calls within 60 minutes.
            </p>
            <p className="privacy-policy-section-text">
              In case of an emergency, please call us immediately at <strong>+1 (833) 493-6236</strong>. 
              Quick response is critical to minimize water damage and prevent further property damage.
            </p>
          </section>

          <section className="privacy-policy-section">
            <h2 className="privacy-policy-section-title">10. Intellectual Property</h2>
            <p className="privacy-policy-section-text">
              All content on this website, including text, graphics, logos, and images, is the 
              property of WaterDamagePro and is protected by copyright laws.
            </p>
            <p className="privacy-policy-section-text">
              You may not reproduce, distribute, or create derivative works from our content 
              without our express written permission.
            </p>
          </section>

          <section className="privacy-policy-section">
            <h2 className="privacy-policy-section-title">11. Changes to Terms</h2>
            <p className="privacy-policy-section-text">
              We reserve the right to update these Terms of Service at any time. Changes will 
              be posted on this page with an updated date.
            </p>
            <p className="privacy-policy-section-text">
              It is your responsibility to review these terms periodically. Continued use of 
              our services after changes constitutes acceptance of the updated terms.
            </p>
          </section>

          <section className="privacy-policy-section">
            <h2 className="privacy-policy-section-title">12. Governing Law</h2>
            <p className="privacy-policy-section-text">
              These Terms of Service shall be governed by and construed in accordance with the 
              laws of the United States of America, without regard to its conflict of law provisions.
            </p>
          </section>

          <section className="privacy-policy-section privacy-policy-contact">
            <h2 className="privacy-policy-section-title">13. Contact Us</h2>
            <p className="privacy-policy-section-text">
              If you have any questions about these Terms of Service, please contact us:
            </p>
            <div className="privacy-policy-contact-info">
              <div className="privacy-policy-contact-item">
                <span>📞</span>
                <div>
                  <strong>Phone:</strong>
                  <a href="tel:+1 (833) 493-6236">+1 (833) 493-6236</a>
                </div>
              </div>
              <div className="privacy-policy-contact-item">
                <span>✉️</span>
                <div>
                  <strong>Email:</strong>
                  <a href="mailto:info@waterdamagepro.com">info@waterdamagepro.com</a>
                </div>
              </div>
              <div className="privacy-policy-contact-item">
                <span>📍</span>
                <div>
                  <strong>Address:</strong>
                  <span>WaterDamagePro, USA</span>
                </div>
              </div>
            </div>
          </section>

          <button className="privacy-policy-back-top" onClick={scrollToTop}>
            ↑ Back to Top
          </button>
        </div>
      </div>
     <Footer/>
    </div>
  );
};

export default TermsOfService;